export default {
  "content": "<path d=\"M17.5 3.5a5 5 0 015 5v5a5 5 0 01-5 5v-2a3 3 0 003-3v-5a3 3 0 00-3-3h-11a3 3 0 00-3 3v5a3 3 0 003 3h3.12a2 2 0 011.328.505l4.216 3.747-1.328 1.495L9.62 18.5H6.5a5 5 0 01-5-5v-5a5 5 0 015-5h11z\" fill=\"#7B61FF\"/><path d=\"M14.75 16a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM14.75 7c2 0 3.5 1.53 3.5 3.46 0 .982-.404 1.808-1.072 2.386-.411.355-.902.6-1.428.746v.908h-2v-2.69l.938-.058c.528-.033.93-.202 1.182-.42.233-.201.38-.477.38-.872 0-.823-.601-1.46-1.5-1.46-.898 0-1.577.651-1.768 1.648l-1.964-.375C11.34 8.586 12.655 7 14.75 7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};